<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close"><i class="fa fa-exclamation-triangle"></i>&nbsp; Accept Tag creation Charge</modal-header>
        </div>
        <p>In requesting Ad Tags for these files for download your account will be charged for <strong>{{ charges.tagUnitCount }}</strong> new Ad Tags at a cost of <strong>{{ currency }}{{charges.tagUnitCount * charges.tagCreateCost }}</strong>. Please note any Ad Tags previously created are still active.
        </p>
        <hr/>
        <form-group>
          <field name="Ad Tag Group Name" :value="options.ad_tag_name" v-model="choices.ad_tag_name"/>
        </form-group>
        <form-group>
          <dropdown name="Ad Tag Type" :options="options.adtags" v-model="choices.ad_tag_type"/>
        </form-group>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="Cancel AdTag request" confirmText="Accept Charge and Generate" confirmTheme="danger" :confirmDisabled="!isReady()"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Field from '@/components/Form/Field/field'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_adtag_confirmation',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Dropdown,
    Field
  },
  props: {
    show: Boolean,
    confirmId: String,
    charges: Object
  },
  data: () => ({
    options: {
      currencies: {
        usd: '$',
        gbp: '£',
        eur: '€'
      },
      adtags: [
        {
          name: 'Otomo',
          value: 'otm'
        },
        {
          name: 'Google Bid Manager',
          value: 'dbm'
        },
        {
          name: 'Google Ad Manager (DFP)',
          value: 'dfp'
        },
        {
          name: 'Google Campaign Manager',
          value: 'dcm'
        },
        {
          name: 'Ad Form',
          value: 'adf'
        },
        {
          name: 'Google Campaign Manager - (INS)',
          value: 'dcm-ins'
        }
      ]
    },
    choices: {}
  }),
  mounted () {},
  computed: {
    charge () {
      const value = this.charges.totalDownloads * this.charges.downloadCost
      return Math.max(0, value)
    },
    currency () {
      return this.options.currencies[this.charges.currency]
    }
  },
  methods: {
    confirm () {
      // take options from form and convert to json object for submission.
      this.$emit('adTagCreateConfirm', this.choices)
      this.close()
    },
    isReady () {
      if (this.choices.ad_tag_type == null || this.choices.ad_tag_type === '' || this.choices.ad_tag_name == null || this.choices.ad_tag_name === '') {
        return false
      } else {
        return true
      }
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-adtag-confirmation.vue